import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Modal } from 'reactstrap';
import { extractAddressComponent, convertCoordsWKT } from '../../../helpers/addressAutoComplete';
import { autoCompleteConfig } from '../../../constants/addressAutoComplete';
import { labels } from '../../../constants/text';
import { getCentPrice, tryParseMonetaryValue } from '../../../helpers/general';
import Validator from '../../common/forms/Validator';
import ErrorMessage from '../../common/forms/ErrorMessage';
import FormActionButtons from '../../common/forms/FormActionButtons';
import Close from '../../common/ui/Close';
import regexMap from '../../../constants/regExps';

export default class AddCustomRateModal extends Validator {
  static propTypes = {
    company_id: PropTypes.number,
    isOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    addCustomRateAction: PropTypes.func.isRequired,
    skillsList: PropTypes.array.isRequired,
    getCompanyDetailsAction: PropTypes.func,
    getGoogleAddressDetails: PropTypes.func
  };

  initialState = {
    job_skill_id: '',
    zip: '',
    state: '',
    city: '',
    coordinates: '',
    pay_rate: '',
    cost_rate: ''
  };

  state = {
    ...this.initialState,
    skill_level_id: this.props.skillLevel
  };

  validationRules = {
    zip: { zipcode: true },
    job_skill_id: { required: true },
    pay_rate: { required: true },
    cost_rate: { required: true }
  };

  handleChange = event => {
    const { value, name } = event.target;
    const intValue = parseInt(value, 10);
    if (intValue) {
      this.setState({
        [name]: intValue
      });
    }
  };

  handleChangeZip = event => {
    const { value } = event.target;
    this.setState({
      zip: value
    });

    if (regexMap.zipcode.test(value)) {
      this.props.getGoogleAddressDetails(value).then(
        data => {
          const addressDetails = data.results[0];
          const { address_components } = addressDetails;
          const { lat, lng } = addressDetails.geometry.location;
          const { city, state, neighborhood } = autoCompleteConfig;
          this.setState({
            state: extractAddressComponent(address_components, state),
            city: extractAddressComponent(address_components, city) || extractAddressComponent(address_components, neighborhood),
            coordinates: convertCoordsWKT(lat, lng)
          });
        }
      );
    } else {
      this.setState({
        state: '',
        city: ''
      });
    }
  };

  handleChangeCostPayRate = event => {
    const { value, name } = event.target;
    const resolvedValue = tryParseMonetaryValue(value);
    if (!_.isNull(resolvedValue)) {
      this.setState({
        [name]: resolvedValue
      });
    }
  };

  clearModal = () => {
    this.setState(this.initialState);
    this.props.toggleModal();
  };

  addNewCustomRate = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      const { addCustomRateAction, company_id, skillsList } = this.props;
      const { job_skill_id, skill_level_id, zip, state, city, coordinates, pay_rate, cost_rate } = this.state;

      const title = skillsList.find(skill => skill.job_skill_id === job_skill_id).reference_title;
      const data = {
        job_skill_id,
        skill_level_id,
        title,
        zip,
        state,
        city,
        coordinates,
        pay_rate: getCentPrice(pay_rate),
        cost_rate: getCentPrice(cost_rate),
        company_id
      };
      addCustomRateAction(data).then(this._refreshData);
    }
  };

  _refreshData = () =>
    this.props.getCompanyDetailsAction(this.props.company_id)
      .then(this.clearModal);

  render () {
    const { isOpen, toggleModal, skillsList } = this.props;
    const { zip, state, city, pay_rate, cost_rate, job_skill_id } = this.state;
    const errors = this.validationErrors;

    return (
      <Modal className='create-modal' isOpen={isOpen} toggle={toggleModal}>
        <div className='modal-header'>
          <div className='modal-title'>Add Custom Rate</div>
          <Close onClick={toggleModal} />
        </div>

        <form className='modal-body' onSubmit={this.addNewCustomRate}>
          <div className='form-group'>
            <label htmlFor='job_skill_id'>Job Skill</label>
            <select
              className='input'
              id='job_skill_id'
              name='job_skill_id'
              value={job_skill_id}
              onChange={this.handleChange}
            >
              <option disabled value=''>Select skill</option>
              {skillsList.map(skill =>
                <option value={skill.job_skill_id} key={skill.id}>
                  {skill.skill_label}
                </option>
              )}
            </select>
            <ErrorMessage errorText={errors.job_skill_id} />
          </div>
          <div className='form-group'>
            <label htmlFor='zip'>Zipcode</label>
            <input
              type='number'
              className='input'
              id='zip'
              name='zip'
              value={zip}
              onChange={this.handleChangeZip}
            />
            <ErrorMessage errorText={errors.zip} />
          </div>
          <div className='form-group'>
            <label htmlFor='state'>State</label>
            <input
              disabled
              className='input'
              id='state'
              value={state}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='city'>City</label>
            <input
              disabled
              className='input'
              id='city'
              value={city}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='pay_rate'>{ labels.pay_rate }</label>
            <input
              type='number'
              min='0'
              step='any'
              className='input'
              id='pay_rate'
              name='pay_rate'
              value={pay_rate}
              onChange={this.handleChangeCostPayRate}
            />
            <ErrorMessage errorText={errors.pay_rate} />
          </div>
          <div className='form-group'>
            <label htmlFor='cost_rate'>{ labels.cost_rate }</label>
            <input
              type='number'
              min='0'
              step='any'
              className='input'
              id='cost_rate'
              name='cost_rate'
              value={cost_rate}
              onChange={this.handleChangeCostPayRate}
            />
            <ErrorMessage errorText={errors.cost_rate} />
          </div>

          <FormActionButtons onClickCancel={this.clearModal} submitTitle='Add' />
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/AddCustomRateModal.js